import { ProductConfigurationVisualProps } from "@omni/types/components/productConfiguration/productConfiguration";
import {
    ConditionParams,
    ProductConfiguration
} from "@omni/types/utils/productConfiguration";
import { isDefined } from "@omni/utils/helper.utils";

import { getFeatureValue } from "@/utils/productConfiguration/visuals/calculator/helpers/calculation.helpers";

import { Calculator } from "../calculator.component";
import { CalculatorConfig, CalculatorSchema } from "../calculator.types";

export const toProductConfiguration = <TSchema extends CalculatorSchema>(
    config: CalculatorConfig<TSchema>
): ProductConfiguration<{}, {}> => {
    const condition = ({ identifier, features }: ConditionParams) => {
        if (!identifier || !features?.length) return false;

        const hasIdentifier = config.identifiers.includes(identifier);

        const hasFeatures = config.variants.some((variant) =>
            variant.codes.every((code) =>
                features.find(
                    (feature) =>
                        feature.code.endsWith(code) &&
                        isDefined(getFeatureValue(feature))
                )
            )
        );

        return hasIdentifier && hasFeatures;
    };

    const visual = (props: ProductConfigurationVisualProps<{}>) => (
        <Calculator<TSchema>
            {...props}
            config={config}
        />
    );

    return {
        condition: condition,
        visual: visual,
        productSubType: "",
        configPaths: [],
        dataPaths: () => ({}),
        previewPath: undefined,
        withOrigin: false
    };
};
